import React from 'react';
import Pro01 from "../../images/services/bc/Blockchain-App-Development-Company.webp";
import {Col, Container, Row} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Agile(props) {
    return (
        <div className="tekrevol_gray_bg p-100">
            <Container classNanme="h-100">
                <Row classNanme="h-100">
                    <Col xs={12} md={6} lg={6} xl={5} xxl={5}>
                        <div className="example" data-text="Company">
                            <h2>Blockchain App Development Company</h2>
                        </div>
                        <p>TekRevol helps startups and enterprises acquire distributed ledger technologies for cutting-edge business applications to help them evolve and make better decisions. We follow agile methodologies for Blockchain technology consulting, custom app development, dApps designing and development, crypto token development, wallets development, smart contracts, and Blockchain security, maintenance, and upgrades.
                        </p>

                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="agile_title my-auto offset-xl-1">
                        {/*<div className="content_pointer">*/}
                        {/*    <div className="pointers_item">*/}
                        {/*        <div className="title_count">17+<span>projects completed</span></div>*/}
                        {/*    </div>*/}
                        {/*    <div className="pointers_item">*/}
                        {/*        <div className="title_count">17+<span>businesses served</span></div>*/}
                        {/*    </div>*/}
                        {/*    <div className="pointers_item">*/}
                        {/*        <div className="title_count">6+<span>industries covered</span></div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        <LazyLoadImage
                            src={Pro01}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Agile;